<template>
  <footer class="bg-black">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 text-center sm:text-left">
        <!-- Colonne Xiaomi -->
        <div>
          <h3 class="text-base font-semibold text-white mb-4 underline">
            Xiaomi
          </h3>
          <ul class="space-y-2">
            <li>
              <router-link
                to="/"
                class="text-sm text-gray-300 hover:text-orange-500 transition-colors"
              >
                Accueil
              </router-link>
            </li>
            <li v-if="!isWaitPage">
              <button
                @click="statusStore.openSuiviModal()"
                class="text-sm text-gray-300 hover:text-orange-500 transition-colors"
              >
                Suivre votre participation
              </button>
            </li>
            <li v-if="!isWaitPage">
              <router-link
                to="/partenaires"
                class="text-sm text-gray-300 hover:text-orange-500 transition-colors"
              >
                Nos enseignes partenaires
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Colonne Aide & Assistance -->
        <div>
          <h3 class="text-base font-semibold text-white mb-4 underline">
            Aide & Assistance
          </h3>
          <ul class="space-y-2">
            <li>
              <router-link
                to="/contact"
                class="text-sm text-gray-300 hover:text-orange-500 transition-colors"
              >
                Contactez-nous
              </router-link>
            </li>
          </ul>
          <div class="mt-2 text-sm text-gray-300 leading-tight">
            <p>Hotline&nbsp;: 09 70 82 00 58</p>
            <p>(appel non surtaxe depuis la France)</p>
            <p>du lundi au vendredi de 9h a 17h</p>
            <p>en precisant le Numéro de l'offre 2025475.</p>
          </div>
        </div>

        <!-- Colonne Informations legales -->
        <div>
          <h3 class="text-base font-semibold text-white mb-4 underline">
            Informations legales
          </h3>
          <ul class="space-y-2">
            <li>
              <a
                href="https://oxoformdocs.fra1.digitaloceanspaces.com/691aec3fe85184ee57dbd4c4/modalites.pdf"
                target="_blank"
                rel="noopener noreferrer"
                class="text-sm text-gray-300 hover:text-orange-500 transition-colors"
              >
                Modalités
              </a>
            </li>
            <li>
              <router-link
                to="/mentions-legales"
                class="text-sm text-gray-300 hover:text-orange-500 transition-colors"
              >
                Mentions legales
              </router-link>
            </li>
            <li>
              <a
                href="https://oxoformdocs.fra1.digitaloceanspaces.com/682ca9b7a6d90af0d3491e0c/politique_de_confidentialite.pdf"
                target="_blank"
                rel="noopener noreferrer"
                class="text-sm text-gray-300 hover:text-orange-500 transition-colors"
              >
                Politique de confidentialite
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Section Decouvrir l'univers Xiaomi -->
    <div class="border-t border-gray-800">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 text-center sm:text-left">
          <p class="text-sm text-gray-300">
            Decouvrir l'univers
            <a
              href="https://www.mi.com/fr"
              target="_blank"
              rel="noopener noreferrer"
              class="text-white underline hover:text-orange-500 transition-colors"
              >Xiaomi</a
            >
          </p>

          <!-- Reseaux sociaux -->
          <div class="flex items-center justify-center sm:justify-start space-x-4">
            <a
              href="https://www.facebook.com/XiaomiFrance"
              target="_blank"
              rel="noopener noreferrer"
              class="text-gray-300 hover:text-white transition-colors"
              aria-label="Facebook"
            >
              <i class="fa-brands fa-facebook-f text-lg"></i>
            </a>
            <a
              href="https://x.com/XiaomiFrance"
              target="_blank"
              rel="noopener noreferrer"
              class="text-gray-300 hover:text-white transition-colors"
              aria-label="X (Twitter)"
            >
              <i class="fa-brands fa-x-twitter text-lg"></i>
            </a>
            <a
              href="https://www.instagram.com/xiaomifrance/"
              target="_blank"
              rel="noopener noreferrer"
              class="text-gray-300 hover:text-white transition-colors"
              aria-label="Instagram"
            >
              <i class="fa-brands fa-instagram text-lg"></i>
            </a>
            <a
              href="https://www.tiktok.com/@xiaomifrance"
              target="_blank"
              rel="noopener noreferrer"
              class="text-gray-300 hover:text-white transition-colors"
              aria-label="TikTok"
            >
              <i class="fa-brands fa-tiktok text-lg"></i>
            </a>
            <a
              href="https://www.twitch.tv/xiaomifrance"
              target="_blank"
              rel="noopener noreferrer"
              class="text-gray-300 hover:text-white transition-colors"
              aria-label="Twitch"
            >
              <i class="fa-brands fa-twitch text-lg"></i>
            </a>
          </div>
        </div>

        <!-- Texte legal RGPD -->
        <div class="mt-6 space-y-4">
          <p class="text-xs text-gray-400 leading-relaxed">
            Conformement a la Loi « Informatique et Libertes du 06.01.1978
            modifiee », ainsi qu'au reglement europeen relatif a la protection
            des donnees (RGPD), vous pouvez faire valoir vos droits d'acces aux
            donnees, de rectification, d'effacement, de portabilite de
            transmission, de limitation du traitement ainsi que vous opposer au
            traitement en formulant votre demande a l'adresse suivante :
          </p>

          <p class="text-xs text-gray-400 font-medium">
            Modelabs Mobile 107 rue de la Boétie 75008 Paris
          </p>

          <p class="text-xs text-gray-400 leading-relaxed">
            Toute demande doit etre claire, precise et justifiee, et accompagnee
            d'une copie d'une piece d'identite et realisee conformement au cadre
            legal applicable. En savoir plus :
            <a
              href="https://oxoformdocs.fra1.digitaloceanspaces.com/682ca9b7a6d90af0d3491e0c/politique_de_confidentialite.pdf"
              target="_blank"
              rel="noopener noreferrer"
              class="text-gray-300 underline hover:text-orange-500 transition-colors"
            >
              Politique de protection des donnees personnelles
            </a>
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { useStatusStore } from "@/stores/status";

export default {
  name: "footer-view",
  data() {
    return {
      statusStore: useStatusStore(),
    };
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    currentPath() {
      return this.$route.path;
    },
    currentYear() {
      return new Date().getFullYear();
    },
    isWaitPage() {
      return this.$route.path === '/wait';
    },
  },
};
</script>
